<template>
  <v-container fluid>
    <v-layout class="mb-4">
      <v-flex xs6 md6>
        <h3 class="title font-weight-bold">Posts</h3>
      </v-flex>
      <v-flex xs6 md6 class="text-xs-right">
        <router-link :to="`/posts/create`">
          <el-button type="danger" size="small">Create Post</el-button>
        </router-link>
      </v-flex>
    </v-layout>

    <el-table :data="postList" style="width: 100%">
      <el-table-column label="ID" width="100">
        <template slot-scope="props">{{props.row.post_id | numFormat('00000')}}</template>
      </el-table-column>
      <el-table-column label="Status" width="200">
        <template slot-scope="props">
          <div
            v-if="props.row.post_status=='published'"
            class="green lighten-2 badge-status"
          >{{props.row.post_status}}</div>
          <div
            v-if="props.row.post_status!='published'"
            class="red lighten-2 badge-status"
          >{{props.row.post_status}}</div>
        </template>
      </el-table-column>
      <el-table-column label="Title">
        <template slot-scope="props">
          <div>
            <strong>{{props.row.post_title}}</strong>
          </div>
          <div>{{props.row.post_slug}}</div>
        </template>
      </el-table-column>
      <el-table-column label="Type">
        <template slot-scope="props">{{props.row.post_type}}</template>
      </el-table-column>

      <el-table-column label align="right" width="200">
        <template slot-scope="props">
          <router-link :to="`/posts/`+props.row.post_slug">
            <el-button type="text" size="small">Detail</el-button>
          </router-link>
        </template>
      </el-table-column>
    </el-table>
  </v-container>
</template>
<script>
import Service from "../../services";

export default {
  components: {},
  data() {
    return {
      postList: []
    };
  },
  created() {
    Service.Cms.getPosts().then(res => {
      this.postList = res.data;
    });
  },
  methods: {
    viewItem(item) {}
  }
};
</script>